const API_BASE_URL_BY_ENV = {
  // development: "http://213.142.132.38/",
  development: "http://localhost",
  production: "https://api.cogitofund.com",
};

const trimTrailingSlash = (url) => url.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL ||
    API_BASE_URL_BY_ENV[process.env.NODE_ENV] ||
    API_BASE_URL_BY_ENV.development,
);
